import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { loadMenu, bindMenuAnimations, convertDesktopMenuToTouch } from './tech.loadMenu';
import { getFacultiesMenuDesktopWrapper, getFacultiesMenuMobileWrapper } from './tech.menuMobile';
import { getCountryMenuWrapper } from "./tech.countryMenu";
import { validatePhone } from "./tech.phone";
//import { saveAndExit, openConfiguration, fadeBanner } from "../js/cookie-banner";
import {phone} from "../js/home";
import * as url from "url";

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

global.menu = null;
global.studiesMenu = [];
global.loadDataMenu = false;
global.loadMenuPromise = null;

const COOKIE_GEOBAR = "tech.geobarCountryCode";
const COOKIE_COOKIE_CONFIG = "tech.cookieConfig";
const COOKIE_WELCOME_COUNTER_NAME = "tech.welcome";
const COOKIE_PAGE_VISIT_NAME = "tech.pageVisit";
const COOKIE_TRACKING_CODE = "tech.trackingCode";
const PAGE_VISIT_IDLE_TIMEOUT = 30; // minutes
export const COOKIE_COUNTRY_CODE = "countryCode";
const AFFILIATE_PARAM = "afcode";
const AFFILIATE_COOKIE = "afCode";
export const COOKIE_CURRENCY_COUNTRY_CODE = "currencyCountryCode";
export const COOKIE_FORCE_COUNTRY_CODE = "forceCountryCode";
export const COOKIE_USER_COUNTRY_CODE = "userCountryCode";
export const COOKIE_LANGUAGE_CODE = "tech.language";
export const COOKIE_PAYMENT = "tech.payment";
export const COOKIE_CONTINET = "continentISO";
export const COOKIE_TECH_COOKIES = "tech.cookies";

const DEFAULT_VALUE_WELCOME_COUNTER = 0;
const MAX_VALUE_WELCOME_MODAL = 6;
const MENU_MODE_TOP = 1;
const MENU_MODE_COLLAPSED = 2;
const MENU_MODE_EXPANDED = 3;
const MENU_MODE_SUBMENU = 4;
var affiliateLibObj = document.getElementById("techAffilatesScript");
const AFFILIATE_LIB = affiliateLibObj ? document.getElementById("techAffilatesScript").value : '';



const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: APPLICATIONINSIGHTS_KEY,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: ['*.vimeo.com', 'vimeo.com', 'developers-ventasonline.payway.com.ar', 'developers.decidir.com','live.decidir.com'],
        disablePageUnloadEvents: ["unload"]
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

var URLS_NOT_SHOW_WELCOME_MODAL = ["/payment", "/pago", "/factura", "/matricula", "/enrolment", "/seleccionar-pais", "/campus", "/einschreibung", "/inscripcion", "/inscription", "/iscrizione", "/matricola", "/mx/educacion/doctorado/doctorado-ciencias-educacion", "/ve/escuela-de-negocios/maestria/maestria-mba-marketing-digital"];

var _currentMenuMode = MENU_MODE_TOP;

var topBar = $('app-header > .navbar');
global.menuBar = $('.app-menu-header > .navbar');
var navLink = $('.app-menu-header .nav-item .nav-link');
var sloganMobile = $('.slogan-mobile');
var sloganMobileText = $('#sloganMobile');
var body = $('body');
var html = $('html');
var main = $('main.main');

var _menuLoaded = false;
var _countryMenuLoaded = false;
var _menuMobileLoaded = false;


var localizedLogos = $('.brand-logos .localized-logo')
var areaLogos = $('.brand-logos .area-logo')

var formValidatorLoaded = false;
var imageToRecalculateOffset = null;
var offsetToChangeClass = 0;
var changeClass = false;



/// PRIVATE FUNCTIONS ///

function shouldShowGeoModal() {
    if (location.href.includes("/tiny/") || location.href.includes("/pago/")) {
        return false;
    } else {
        var sameCountry = getSelectedCountryCode() === getCookie("userCountryCode");
        if (!sameCountry) {
            return window.sessionStorage.getItem(COOKIE_GEOBAR) !== "1"
        } else {
            window.sessionStorage.setItem("tech.geobarCountryCode", "1");
            return false;
        }
        //console.log(window.sessionStorage.getItem(COOKIE_GEOBAR), window.sessionStorage.getItem(COOKIE_GEOBAR) !== "1")
        //return window.sessionStorage.getItem(COOKIE_GEOBAR) !== null && window.sessionStorage.getItem(COOKIE_GEOBAR) !== "1";
        //return getCookie(COOKIE_GEOBAR).length === 0;
    }
}

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

function shouldShowCookiesBanner() {
    let ck = getCookie(COOKIE_TECH_COOKIES);
    console.log(ck);
    if (ck.length > 0) {
        let cookies = getConsentCookies();
        updateConsentCookies(cookies);
        return false;
    } else {
        return true;
    }
}

function updateConsentCookies(cookies) {
    gtag('consent', 'update', {
        'ad_storage': cookies.ad_storage,
        'ad_user_data': cookies.ad_user_data,
        'ad_personalization': cookies.ad_personalization,
        'analytics_storage': cookies.analytics_storage,
        'personalization_storage': cookies.personalization_storage,
        'functionality_storage': cookies.functionality_storage,
        'security_storage': cookies.security_storage
    });
    dataLayer.push({
        'event': 'consent_update',
        'ad_storage': cookies.ad_storage,
        'ad_user_data': cookies.ad_user_data,
        'ad_personalization': cookies.ad_personalization,
        'analytics_storage': cookies.analytics_storage,
        'personalization_storage': cookies.personalization_storage,
        'functionality_storage': cookies.functionality_storage,
        'security_storage': cookies.security_storage
    });
}

export function setConsentCookies(cookies) {
    var defaultDuration = 365 * 24 * 60 * 60 * 1000; //expires 1 year
    Object.keys(cookies).forEach(key => {
        setCookie(key, cookies[key], defaultDuration);
    })
    setCookie(COOKIE_TECH_COOKIES, "setted", defaultDuration);
    updateConsentCookies(cookies);
}

function getConsentCookies() {
    const navCookies = document.cookie.split(';');
    var cookies = {ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied', personalization_storage: 'denied', functionality_storage: 'denied', security_storage: 'granted'};
    for( let ck of navCookies ) {
        const [cookieName, cookieValue] = ck.split('=').map(c => c.trim());
        switch (cookieName) {
            case "ad_storage":
                cookies.ad_storage = decodeURIComponent(cookieValue);
                break;
            case "ad_user_data":
                cookies.ad_user_data = decodeURIComponent(cookieValue);
                break;
            case "ad_personalization":
                cookies.ad_personalization = decodeURIComponent(cookieValue);
                break;
            case "analytics_storage":
                cookies.analytics_storage = decodeURIComponent(cookieValue);
                break;
            case "personalization_storage":
                cookies.personalization_storage = decodeURIComponent(cookieValue);
                break;
            case "functionality_storage":
                cookies.functionality_storage = decodeURIComponent(cookieValue);
                break;
            case "security_storage":
                cookies.security_storage = decodeURIComponent(cookieValue);
                break;
            default:
                break;
        }
    }
    return cookies;
}

export function trackingCookieEnabled() {
    let cookies = getConsentCookies();
    let ueConsent = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","IS","LI","NO","SE","GB","CH"]
    if (ueConsent.includes(getCookie(COOKIE_USER_COUNTRY_CODE))) {
        //check if tracking cookie granted and return true;
        return getCookie("ad_user_data") === "granted";
    } else {
        return true;
    }
}

function shouldShowWelcomeModal() {
    var inUrl = false;
    for (var i in URLS_NOT_SHOW_WELCOME_MODAL) {
        var item = URLS_NOT_SHOW_WELCOME_MODAL[i];
        if (window.location.href.includes(item)) {
            inUrl = true;
            break;
        }
    }
    var welcomeModalStatus = document.body.dataset.welcomeModalStatus;
    if (welcomeModalStatus === "hide" || isAffiliate() || inUrl || shouldShowGeoModal() || getCookie(COOKIE_PAYMENT) !== "") {
        return false;
    } else {
        return true;
    }
}

function isAffiliate() {

    var cookie = getCookie(AFFILIATE_COOKIE);
    var param = getParameterByName(AFFILIATE_PARAM)
    return cookie !== "" || param != null;
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getInternationalUrl(url) {
    var countryCode = getSelectedCountryCode() || "es";
    var languageCode = getSelectedLanguageCode() || "es";
    console.log("LANGUAGE AND COUNTRY", countryCode, languageCode, url);
    if (countryCode.toLowerCase() != "es") {
        console.log("Entro en if URL", url)
        console.log("Return:", '/' + languageCode.toLowerCase() + '-' + countryCode.toLowerCase() + url)
        return url.charAt(0) == '/' ? '/' + languageCode.toLowerCase() + '-' + countryCode.toLowerCase() + url : '/' + languageCode.toLowerCase() + '-'+ countryCode.toLowerCase() + '/' + url;
    }
    console.log(url)
    return "/" + languageCode + "-" + countryCode + url;
}
export function getSelectedCountryCode() {
    if (!window.location.href.includes('/pago')) {
        var path = window.location.pathname;
        console.log("PATH INIT:", path);
        if (path.indexOf('/') == 0) {
            path = path.substring(1);
        }
        console.log("PATH SUBSTRING:", path);
        var parts = path.split('/');
        console.log("PARTS INIT:", parts);
        console.log("PART 0:", parts[0], "PART SPLIT:", parts[0].split('-'));
        if (parts.length > 0 && parts[0].split('-')[1].length == 2) {
            return parts[0].split('-')[1].toUpperCase();
        }
        return "ES";
    }
    return "ES";
}

export function getSelectedLanguageCode() {
    if (!window.location.href.includes('/pago')) {
        var path = window.location.pathname;
        if (path.indexOf('/') == 0) {
            path = path.substring(1);
        }
        var parts = path.split('/');
        if (parts.length > 0 && parts[0].split('-')[0].length == 2) {
            return parts[0].split('-')[0].toUpperCase();
        }
        return "ES";
    }
    return "ES";
}

export function footerCookieBanner() {
    //getCookieBanner(true);
}

export function getCookieBanner() {
    console.log("Entering getCookieBanner")
    $.ajax({
        type: 'GET',
        cache: false,
        url: getInternationalUrl('/Home/GetCookieBanner'),
        success: function (content) {
            body.append(content);
        }
    })
    console.log("Body OFF CookieBanner EVENT")
    body.off('click', getCookieBanner);
    body.off('keydown', getCookieBanner);
    body.off('mousemove', getCookieBanner);
    body.off('touchstart', getCookieBanner);
}

function getCountrySelectorData() {
    $.ajax({
        type: 'POST',
        url: getInternationalUrl('/Home/_DataCountrySelector'),
        data: { url: window.location.pathname },
        success: function (content) {
            if (!location.href.includes('/tiny/') || !location.href.includes('/pago/')) {
                body.append(content);
                if (!content || content.length == 0) {
                    // not showing up geo modal, then load welcome modal that had been blocked before
                    if (shouldShowWelcomeModal()) {
                        getWelcomeModalData();
                    }
                }
                //techGeoModal.showCountryGeolocalization();
            }
        },
        error: function (xhr, status, error) {
            if (shouldShowWelcomeModal()) {
                getWelcomeModalData();
            }
        }
    })
    body.off('click', getCountrySelectorData);
    body.off('keydown', getCountrySelectorData);
    body.off('mousemove', getCountrySelectorData);
    body.off('touchstart', getCountrySelectorData);
}

export function sendTrackLead() {
    // Get attributes from current page
    if (getCookie("techTracking").length === 0) return;
    var facultyName = body.data('faculty-name');
    var courseTypeName = body.data('coursetype-name');
    var userCountryCode = getCookie("userCountryCode");
    var trackingData = JSON.parse(getCookie("techTracking"));
    let name = "";
    let phone = "";
    let email = "";
    for (let v in trackingData) {
        if (v === "Name") name = trackingData[v];
        if (v === "Email") email = trackingData[v];
        if (v === "Phone") phone = trackingData[v];
    }
    let price = "";
    let cCode = "";
    let cId = 0;
    let currency = "";
    let specialities = "";
    let courseTitle = "";
    let courseData = document.getElementById("course-data-info");
    if (courseData !== null) {
        price = courseData.getAttribute("data-course-price-value");
        cCode = courseData.getAttribute("data-course-code");
        currency = courseData.getAttribute("data-course-currency");
        cId = Number.parseInt(courseData.getAttribute("data-course-original-id"));
        specialities = courseData.getAttribute("data-specialities");
        courseTitle = courseData.getAttribute("data-course-title");
    }

    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Home/SendTrackingData'),
        data: {
            Name: name,
            Phone: phone,
            Email: email,
            Url: window.location.href,
            CountryCode: userCountryCode,
            FacultyName: facultyName,
            CourseTypeName: courseTypeName,
            Price: price,
            CourseCode: cCode,
            Currency: currency,
            OriginalCourseId: cId,
            Specialities: specialities,
            CourseTitle: courseTitle,
        },
        success: function(content) {

        },
        complete: function() {

        },
        error: function() {

        }
    })
}

function getWelcomeModalData() {
    var facultyName = body.data('faculty-name');
    var courseTypeName = body.data('coursetype-name');
    let countryCode = window.location.pathname.slice(1).split('/')[0].split('-')[1];
    let languageCode = window.location.pathname.slice(1).split('/')[0].split('-')[0];
    let userCountryCode = getCookie("userCountryCode");

    $.ajax({
        type: 'GET',
        url: getInternationalUrl('/Home/_DataWelcomeModal'),
        data: { faculty: facultyName != null ? facultyName : '', courseType: courseTypeName != null ? courseTypeName : '', userCountryCode: userCountryCode, languageCode: languageCode, countryCode: countryCode },
        success: function (content) {
            if (window.location.hash) {
                setTimeout(showWelcomeModal, 1000);
            } else {
                showWelcomeModal();
            }

            function showWelcomeModal() {
                body.append(content);
                var welcomeModal = $('div#welcomeModal');
                bindCustomCheckbox('#welcomeModal');

                welcomeModal.on('shown.bs.modal', function () {

                    $(this).find('label').addClass('active')
                }).on('hidden.bs.modal', function () {
                    $(this).find('label').removeClass('active')
                })

                welcomeModal.modal('show')

                $(document).on('click', '#welcomeModal input', function formFirstClick() {
                    loadFormValidator('#welcomeForm')
                    $(document).off('click', '#welcomeModal input', formFirstClick)
                });
            }

        }
    })
    body.off('click', getWelcomeModalData);
    body.off('keydown', getWelcomeModalData);
    body.off('mousemove', getWelcomeModalData);
    body.off('touchstart', getWelcomeModalData);
}

function encodeUrl(url) {
    var urlProcessed = removeAccents(decodeURIComponent(url));
    var urlParts = urlProcessed.split('?');
    if (urlParts.length == 1) {
        return urlProcessed;
    } else {
        var query = urlParts[1];
        if (query.indexOf('&') !== -1) {
            query = query.split('&').join('##amp##');
        }
        if (query.indexOf('/') !== -1) {
            query = query.split('/').join('##slash##');
        }
    }
    return urlParts[0] + '##query##' + query;
}

function removeAccents(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}

export function getCookie(cname, exitOnError) {
    var name = cname + "=";
    try {
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    } catch {
        if (cname === COOKIE_PAGE_VISIT_NAME) {
            setPageVisitCookie(true);
            if (!exitOnError) {
                return getCookie(cname, true);
            }
        }
    }
}

function navBarCollapse() {
    var position = $(window).scrollTop();

    if (position > 0) {
        switchMenu(MENU_MODE_COLLAPSED)
    }

    $(window).scroll(function () {
        if (_currentMenuMode == MENU_MODE_SUBMENU) {
            return;
        }
        var scroll = $(window).scrollTop();

        if (imageToRecalculateOffset !== null && imageToRecalculateOffset.length > 0) {
            moveOnScroll(scroll, position);
        }
        if (scroll > 0) {
            switchMenu(MENU_MODE_COLLAPSED)
            if (scroll > position) {
                // scrolling downwards

            } else {
                // scrolling upwards 
                switchMenu(MENU_MODE_EXPANDED)
            }
        } else {
            switchMenu(MENU_MODE_TOP)
        }
        position = scroll;
    });
}

function switchMenu(mode) {

    if (mode == MENU_MODE_COLLAPSED) {
        topBar.addClass('collapsed');
        sloganMobileText.addClass('slogan-mobile-tiny');
        if (!menuBar.is('.transparent-bg') || (menuBar.is('.transparent-bg') && changeClass)) {
            menuBar.addClass('white-bg collapsed');
            navLink.removeClass('nav-link-shadow');
        } else {
            menuBar.removeClass('white-bg');
            menuBar.addClass('collapsed');
            navLink.addClass('nav-link-shadow');
        }
        menuBar.removeClass('collapsed-scrolled-top');
        body.removeClass('scrolling-up')
        main.addClass('header-collapsed');

    } else if (mode == MENU_MODE_EXPANDED) {
        topBar.addClass('collapsed');
        main.addClass('header-collapsed');
        if (!menuBar.is('.transparent-bg') || (menuBar.is('.transparent-bg') && changeClass)) {
            menuBar.addClass('white-bg collapsed');
            navLink.removeClass('nav-link-shadow');
        } else {
            menuBar.removeClass('white-bg');
            menuBar.addClass('collapsed');
            navLink.addClass('nav-link-shadow');
        }
        menuBar.addClass('collapsed-scrolled-top');
        body.addClass('scrolling-up');
        sloganMobileText.removeClass('slogan-mobile-tiny');




    } else if (mode == MENU_MODE_TOP) {
        topBar.removeClass('collapsed');
        sloganMobile.removeClass('collapsed');
        main.removeClass('header-collapsed');
        menuBar.removeClass('collapsed collapsed-scrolled-top');
        if (!menuBar.is('.always-white')) {
            menuBar.removeClass('white-bg');
            navLink.addClass('nav-link-shadow');

        }
        body.removeClass('scrolling-up')

    } else if (mode == MENU_MODE_SUBMENU) {
        topBar.removeClass('collapsed');
        sloganMobile.removeClass('collapsed');
        if (!menuBar.is('.transparent-bg') || (menuBar.is('.transparent-bg') && changeClass)) {
            menuBar.addClass('white-bg collapsed');
            navLink.removeClass('nav-link-shadow');
        } else {
            menuBar.removeClass('white-bg');
            menuBar.addClass('collapsed');
            navLink.addClass('nav-link-shadow');
        }
        menuBar.removeClass('collapsed collapsed-scrolled-top');

    }
    _currentMenuMode = mode;

}
export function setPaymentCookie(value) {
    setCookie(COOKIE_PAYMENT, value, (30 * 24 * 60 * 60 * 1000));
}

export function setCookie(cookieName, cookieValue, duration) {
    var d = new Date();
    var cookieDuration = duration || (1 * 24 * 60 * 60 * 1000);
    d.setTime(d.getTime() + cookieDuration);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}
export function setSessionCookie(cookieName, cookieValue) {
    document.cookie = cookieName + "=" + cookieValue + ";" + ";path=/";
}
function activateValidatorFor(formRef) {
    var form = $(formRef);
    if (form.length > 0) {
        $.validator.unobtrusive.parse(form);
        form.find('input,textarea').on('focus', function () {
            $(this).prev('label').addClass('active');
        })
        form.find('input,textarea').on('blur', function () {
            if (!$(this).val()) {
                $(this).prev('label').removeClass('active');
            }
        });
    }
}

/// END OF: PRIVATE FUNCTIONS ///


/// PUBLIC FUNCTIONS ///


export function openNewTab(url) {
    $('<a/>').attr('target', '_blank').attr('href', url).get(0).click()
}

export function bindCustomCheckbox(wrapper, callback) {
    var checkBoxOnCLick = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();

        var obj = $(this);
        let checked = false;
        if (obj.is('.checked')) {
            obj.removeClass('checked').find('.checked').removeClass('checked').addClass('unchecked');
            obj.find('input[type="checkbox"]').prop('checked', false);
            obj.find('input[type="checkbox"]').attr('checked', false);
        } else {
            obj.addClass('checked').find('.unchecked').removeClass('unchecked').addClass('checked');
            obj.find('input[type="checkbox"]').prop('checked', true);
            obj.find('input[type="checkbox"]').attr('checked', true);
            checked = true;
        }
        if (typeof callback === 'function') {
            callback(checked);
        }
    };
    if (wrapper) {
        $(wrapper + ' .checkbox').on('click', checkBoxOnCLick);
    } else {
        $('.checkbox').on('click', checkBoxOnCLick);
    }
}

export function setPageVisitCookie(forceSet) {
    var currentCookie = forceSet ? '' : getCookie(COOKIE_PAGE_VISIT_NAME);
    var currentDate = new Date();
    var content = {
        firstAccess: {
            url: encodeUrl(window.location.href),
            time: currentDate.getTime()
        },
        lastAccess: {
            url: encodeUrl(window.location.href),
            time: currentDate.getTime()
        }
    };

    if (currentCookie !== "") {
        // cookie is already set
        // update lastAccess and firstAccess only if it is 
        // older than currentDate - PAGE_VISIT_IDLE_TIMEOUT (minutes)

        content = JSON.parse(unescape(currentCookie));
        var maxIdleDate = new Date();
        maxIdleDate.setTime(new Date().getTime() - (PAGE_VISIT_IDLE_TIMEOUT * 60 * 1000))
        var lastAccessDate = new Date();
        lastAccessDate.setTime(content.lastAccess.time);

        if (lastAccessDate < maxIdleDate) {
            // renew firstAccess url
            content.firstAccess = {
                url: encodeUrl(window.location.href),
                time: currentDate.getTime()
            };
        }
        // renew lastAccess url
        content.lastAccess = {
            url: encodeUrl(window.location.href),
            time: currentDate.getTime()
        };

    }
    if (content) {
        currentDate.setTime(currentDate.getTime() + (365 * 24 * 60 * 60 * 1000)); // expires 1 year
        var expires = "expires=" + currentDate.toUTCString();
        document.cookie = COOKIE_PAGE_VISIT_NAME + "=" + escape(JSON.stringify(content)) + ";" + expires + ";path=/";
    }
    var currentUrlInputs = $('input[name="CurrentUrl"]');
    if (currentUrlInputs.length > 0) {
        currentUrlInputs.val(encodeUrl(window.location.href));
    }
}

function loadCustomPageViewEvent() {
    /*$.ajax({
        url: getInternationalUrl('/Tracking/GeneratePageView'),
        success: function (result) {
            if (result) {
                body.append(result);
            }
        }
    })*/
}

export function sendGAEvent(obj) {
    console.log(obj);
    if (dataLayer) {
        dataLayer.push(obj);
    }
}

export function loadFormValidator(formRef, callback) {
    if (formValidatorLoaded) {
        activateValidatorFor(formRef);
        if (typeof callback !== 'undefined') {
            callback();
        }
        return;
    }
    formValidatorLoaded = true;

    loadScripts([
        'https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.1/jquery.validate.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/jquery-validation-unobtrusive/3.2.11/jquery.validate.unobtrusive.min.js'
    ], function () {
        if ($.validator) {
            // extend jquery range validator to work for required checkboxes
            $.validator.defaults.ignore = "";
            var defaultRangeValidator = $.validator.methods.range;
            $.validator.methods.range = function (value, element, param) {
                if (element.type === 'checkbox') {
                    // if it's a checkbox return true if it is checked
                    return element.checked;
                } else {
                    // otherwise run the default validation function
                    return defaultRangeValidator.call(this, value, element, param);
                }
            };
            activateValidatorFor(formRef);
        }
        if (typeof callback !== 'undefined') {
            callback();
        }
    })
}
export function loadScripts(array, callback) {
    var loader = function (src, handler) {
        var script = document.createElement("script");
        script.src = src;
        script.onload = script.onreadystatechange = function () {
            script.onreadystatechange = script.onload = null;
            if (/MSIE ([6-9]+\.\d+);/.test(navigator.userAgent)) window.setTimeout(function () { handler(); }, 8, this);
            else handler();
        }
        var body = document.getElementsByTagName("body")[0];
        (body || document.body).appendChild(script);
    };
    (function run() {
        if (array.length != 0) {
            loader(array.shift(), run);
        } else {
            callback && callback();
        }
    })();
}

export function setCookieConfig(cookieConfig) {
    setCookie(COOKIE_COOKIE_CONFIG, cookieConfig, (30 * 24 * 60 * 60 * 1000));
}

// export function setCountryCookie(countryCode, ref, redirectUrl, setCurrencyCookie) {
//     setCookie(COOKIE_COUNTRY_CODE, countryCode)
//
//     if (setCurrencyCookie) {
//         setCookie(COOKIE_CURRENCY_COUNTRY_CODE, countryCode)
//         if (getCookie(COOKIE_USER_COUNTRY_CODE) === "") {
//             setCookie(COOKIE_USER_COUNTRY_CODE, countryCode)
//         }
//     }
//
//     var selectedCountry = $(ref);
//     selectedCountry.parents('.countries').find('.selected').removeClass('selected');
//     selectedCountry.addClass('selected');
//     $('.nav-link.country .country-code').text(selectedCountry.text());
//
//     if ($('.country-menu').is('.open')) {
//         toggleHeaderMenu('.country-menu');
//     }
//     if (redirectUrl && redirectUrl !== "") {
//         // window.location.assign(redirectUrl);    
//         window.history.replaceState({}, "", redirectUrl);
//     }
//     window.location.reload();
//
// }

export function setCookieWelcome(forceCounter) {
    var d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    var actualCounter = DEFAULT_VALUE_WELCOME_COUNTER;
    var cookieChecker = getCookie(COOKIE_WELCOME_COUNTER_NAME);

    if (cookieChecker !== "") {
        actualCounter = parseInt(cookieChecker);
    }
    if (actualCounter <= MAX_VALUE_WELCOME_MODAL) {
        actualCounter++;
    }
    if (forceCounter) {
        actualCounter = forceCounter;
    }
    document.cookie = COOKIE_WELCOME_COUNTER_NAME + "=" + actualCounter + ";" + expires + ";path=/";
}

export function setCookieComercial(param) {
    var d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();

    document.cookie = COMMERCIAL_COOKIE + "=" + param + ";" + expires + ";path=/";
}

export function mobileMenuGoLevel(level) {
    if (level == 0) {
        // root
        $('.sidebar.open').removeClass('open openNext')
        $('.sidebar:eq(0)').addClass('open')
    } else {
        $('.sidebar.open:not(.sidebar.open:eq(0))').removeClass('open openNext')
        $('.sidebar:lt(' + (level + 1) + ')').addClass('open')
        $('.sidebar:lt(' + level + ')').addClass('openNext')
    }
}

function toggleMobileMenuWrapper() {
    var menu = $('.sidebar:first-child');
    var hamburguer = $('.hamburguer');

    if (hamburguer.is('.open')) {
        // Close
        hamburguer.removeClass('open');
        menu.hide();
        menu = $('.sidebar');
        menu.removeClass('open');
    } else {
        // Open
        hamburguer.addClass('open');
        menu.show();
        menu.addClass('open');
    }
}

export function toggleMobileMenu() {
    var desktopLoader = $('.faculties-menu-desktop-wrapper .loading');
    if (desktopLoader.length > 0) {
        desktopLoader.remove();
    }
    if (!_menuMobileLoaded) {
        toggleMobileMenuWrapper();
        getFacultiesMenuMobileWrapper(() => {
            if (window.USER_IS_TOUCHING) {
                convertDesktopMenuToTouch();
            }
            loadMenu('mobile', null);
            $('.sidebar input[name="terms"]').on('keyup', function (ev) {
                if (ev.which == 13) {
                    $(this).parents('form')[0].submit();
                }
            })
            _menuMobileLoaded = true;
        });
    } else {
        toggleMobileMenuWrapper();
    }
}

export function toggleRTLMode() {
    document.documentElement.classList.toggle('rtl');
}

export function toggleHeaderMenuWrapper(ref, ids) {
    //Close opened menus
    var elem = $(ref);
    let topMenu = $('.top-menu');
    topMenu.not(elem).removeClass('open');
    let rightMenu = $('.right-menu');
    rightMenu.not(elem).removeClass('open');
    elem.toggleClass('open');

    if (elem.is('.open')) {
        //open
        topMenu.find('.nav-link.selected').removeClass('selected')
        topMenu.find('.options').html('')
        topMenu.find('.second-options').html('').hide();
        switchMenu(MENU_MODE_SUBMENU)

        // bind event to Close menu when click outside
        var closeMenuClickOutside = function (e) {
            if (!elem.is(e.target) // if the target of the click isn't the container...
                &&
                elem.has(e.target).length === 0) // ... nor a descendant of the container
            {
                if (elem.is('.open')) {
                    toggleHeaderMenu(ref, ids);
                }
                $(document).off('click', closeMenuClickOutside)
            }
        }
        setTimeout(function () { $(document).on('click', closeMenuClickOutside) }, 200)

    } else {
        //close
        switchMenu($(window).scrollTop() <= 0 ? MENU_MODE_TOP : MENU_MODE_COLLAPSED);
    }
}

export function toggleHeaderMenuMobile(ref) {
    const data = {
        AreaId: getValueOrNull("AreaId"),
        CourseTypeCountryId: getValueOrNull("ctbID"),
        SpecialityId: getValueOrNull("SpecialityId"),
        CourseCode: getValueOrNull("courseCode")
    };
    if (!_countryMenuLoaded) {
        $('#loaderBox').removeClass('loader-from-top').addClass('loader-from-right');
        showMenu(ref);
        getCountryMenuWrapper(data, () => {
            _countryMenuLoaded = true;
            loadMenu('desktop', ref);
            data;
        });
    } else {
        var elem = $(ref);
        elem.toggleClass('open');
    }
}

export function toggleHeaderMenu(ref) {
    const data = {
        AreaId: getValueOrNull("AreaId"),
        CourseTypeCountryId: getValueOrNull("ctbID"),
        SpecialityId: getValueOrNull("SpecialityId"),
        CourseCode: getValueOrNull("courseCode")
    };
    if (ref == ".country-menu") {
        $('#loaderBox').removeClass('loader-from-top').addClass('loader-from-right');
        if (!_countryMenuLoaded) {
            showMenu(ref);
            getCountryMenuWrapper(data, () => {
                _countryMenuLoaded = true;
                loadMenu('desktop', ref);
                data;
            });
        } else {
            toggleHeaderMenuWrapper(ref);
        }
    } else {
        $('#loaderBox').removeClass('loader-from-right').addClass('loader-from-top');
        if (!_menuLoaded) {
            showMenu(ref);
            getFacultiesMenuDesktopWrapper(() => {
                if (window.USER_IS_TOUCHING) {
                    convertDesktopMenuToTouch();
                }
                _menuLoaded = true;
                loadMenu('desktop', ref);
            });
        } else {
            toggleHeaderMenuWrapper(ref);
        }
    }
}
function getValueOrNull(id) {
    const el = document.getElementById(id);
    return el && el.value !== "" ? el.value : null;
}
export function closeMenu() {
    $('.top-menu').removeClass('open');
    $('.page-content').click();
}


function showMenu(ref) {
    $('#faculties-menu-desktop-wrapper #tech-navigation').show();
    menuBar.addClass('white-bg-loader');
    $('.navbar-options-section-header li a').removeClass('nav-link-shadow');
    var elem = $(ref);
    elem.toggleClass('open');
}

export function switchModalForm(ref) {
    var parent = $(ref).parents('.modal-body-wrap');
    if (parent.length == 0) {
        parent = $(ref).parents('.modal-body');
    }
    var target = parent.eq(0);
    target.children(':not(script):visible').remove();
    target.children(':not(script):hidden').show();
}

export function showModalExtraDiscounts(obj) {
    $(obj).hide();
    $('.modal-discount-extra').show();
}

export function getPromotionalCodeAfterVal() {
    var form = $("#welcomeForm");
    form.find('input, textarea').each(function () {
        $(this).val($.trim($(this).val()))
    })

    var btn = $('#welcomeModal .modal-footer-btn');

    btn.html(btn.data('loading-text')).prop('disabled', true);

    var appWelcomeModal_GeneralValidationError = $('app-welcome-modal .general-validation-error');

    appWelcomeModal_GeneralValidationError.text('');
    form.find('input[name="CurrentUrl"]').val(window.location.href);

    var courseDetailBox = $('#course-data-info');
    var isCoursePage = courseDetailBox.attr('data-page-type');
    if (courseDetailBox.length > 0) {
        // update currency and course price
        form.find('input[name="WelcomeCourseCurrency"]').val(courseDetailBox.attr('course-currency'));
        form.find('input[name="WelcomeCoursePrice"]').val(courseDetailBox.attr('course-price'));
        form.find('input[name="WelcomeCourseCode"]').val(courseDetailBox.attr('course-code'));
        form.find('input[name="WelcomeCoursePriceValue"]').val(courseDetailBox.attr('course-price-value'));
        form.find('input[name="WelcomeCourseType"]').val(courseDetailBox.attr('course-type'));
        if (isCoursePage !== 'undefined' && isCoursePage !== false) {
            form.find('input[name="IsCoursePage"]').val('true');
        }
    }

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
        success: function (content) {
            var target = $('app-welcome-modal .modal-body-wrap');
            target.children().hide();
            target.append(content);
            setCookieWelcome(MAX_VALUE_WELCOME_MODAL + 1);
        },
        error: function () {
            appWelcomeModal_GeneralValidationError.text('Debes rellenar todos los campos obligatorios.');
        },
        complete: function () {
            btn.html(btn.data('text')).prop('disabled', false);
        }
    })
}
export function getPromotionalCode() {

    var $btn = $("#button-modal-enviar");
    $btn.text("Enviando...");

    var CountryRecaptchaEnabledObj = document.getElementById("CountryRecaptchaEnabled");
    var CountryRecaptchaEnabled = CountryRecaptchaEnabledObj ? document.getElementById("CountryRecaptchaEnabled").value.split("-") : [];
    var itemCaller = document.getElementsByClassName('welcome-fields form-group')[0];
    var validacion = document.getElementById("IsRecaptcha").value === "true" ? true : false;
    validacion = true;
    var sendPromoCode = function () {
        var form = $("#welcomeForm");
        form.find('input, textarea').each(function () {
            $(this).val($.trim($(this).val()))
        })
        let validForm = form.valid();
        var extensionEnabled = document.getElementById("extensionInputValue").value;

        if (extensionEnabled) {
            var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
            var vanillaForm = document.getElementById("welcomeForm");
            var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
            var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);

            if (validatePhone(phoneNumber, countrySelected) === false) {
                let errorSpan = document.getElementById("welcome-phone-error-span");
                errorSpan.classList.remove('field-validation-valid');
                errorSpan.innerText = translations.tlfError;
                validForm = false;
            }
        }


        if (validForm) {
            var vanForm = document.getElementById('welcomeForm');
            setTrackingCookie(vanForm);
            if (validacion == true) {
                tech.captchaV3.reCaptcha(itemCaller, tech.core.getPromotionalCodeAfterVal, "GeneratePromoCode");
            } else {
                getPromotionalCodeAfterVal();
            }
        } else {
            $btn.prop("disabled", false).text("Enviar");
        }
    }
    loadFormValidator('#welcomeForm', sendPromoCode);
}

export function setTrackingCookie(form) {
    if (getCookie("techTracking").length === 0) {
        let name = form.querySelector('input[name="Name"]').value;
        let phone = form.querySelector('input[name="PhoneNumber"]').value;
        let email = form.querySelector('input[name="Email"]').value;
        let cookie = {"Name": name, "Phone": phone, "Email": email};
        setCookie("techTracking", JSON.stringify(cookie), 30 * 24 * 60 * 60 * 1000);
    }
}

function getTranslation(translations, code, defaultTranslation) {
    return translationExists(translations, code) ? translations[code] : defaultTranslation;
}

function translationExists(translations, code) {
    return !!translations && !!translations[code];
}

function cleanCountryParams() {
    var url = window.location.href;
    var pais = getParameterByName('pais', url);
    var idioma = getParameterByName('idioma', url);
    var t = getParameterByName('t', url);
    if (pais !== null) {
        setCookie(COOKIE_FORCE_COUNTRY_CODE, pais)
    }
    if (pais !== null || idioma !== null || t !== null) {
        url = url.split('?')[0];
        window.history.replaceState({}, "", url);
    }
}

function checkAndSetTrackingCookie() {
    if (getCookie(COOKIE_TRACKING_CODE).length === 0) {
        var url = window.location.href;
        var trackingCode = getParameterByName('tc', url);
        if (trackingCode !== null) {
            setCookie(COOKIE_TRACKING_CODE, trackingCode, (7 * 24 * 60 * 60 * 1000));
        }
    }
}

//Begin Check Contact button//
export function checkContactForm(formRef, buttonRef, callback) {
    let callbackResult = true;
    if (typeof callback === "function") {
        callbackResult = callback();
    }
    var button = $(buttonRef);
    var form = $(formRef);
    if (form.valid() && callbackResult) {
        button.prop('disabled', false);
    } else {
        button.prop('disabled', true);
    }
}

export function onAudioToggleClick(vimeoPlayer) {
    $(".audio-toggle").on('click', function () {
        var $this = $(this);
        if ($this.is('.muted')) {
            $this.removeClass('muted')
            $this.parents('.video').eq(0).find('video').prop('muted', false)
            if (vimeoPlayer) {
                vimeoPlayer.setVolume(1);
            }
        } else {
            $this.addClass('muted')
            $this.parents('.video').eq(0).find('video').prop('muted', true)
            if (vimeoPlayer) {
                vimeoPlayer.setVolume(0);
            }
        }
    });
}
//End Check Contact button

export function checkDefenderForm(formRef, buttonRef, callback) {
    let callbackResult = true;
    if (typeof callback === "function") {
        callbackResult = callback();
    }
    var button = $(buttonRef);
    var form = $(formRef);
    if (form.valid() && callbackResult) {
        button.prop('disabled', false);
    } else {
        button.prop('disabled', true);
    }
}
function updateHistoricUrls() {
    const key = "historicUrls";
    const existingCookie = getCookie(key);
    var historicUrls = existingCookie ? JSON.parse(decodeURIComponent(existingCookie)) : {};
    const timeStamp = Date.now();
    const url = window.location.href;
    historicUrls[timeStamp] = url;
    document.cookie = key + "=" + encodeURIComponent(JSON.stringify(historicUrls)) + "; path=/";
}

//MAIN FUNCTION//
$(function () {
    updateHistoricUrls();
    var langParam = getParameterByName('idioma', window.location.href);
    setLanguageCookie(langParam);
    cleanCountryParams();
    checkAndSetTrackingCookie();

    // var selectedCountry = getSelectedCountryCode();
    // if (getCookie(COOKIE_COUNTRY_CODE) !== selectedCountry) {
    // setCookie(COOKIE_COUNTRY_CODE, selectedCountry);
    // }
    if (shouldShowGeoModal()) {
        body.one('click', getCountrySelectorData);
        body.one('keydown', getCountrySelectorData);
        body.one('mousemove', getCountrySelectorData);
        body.one('touchstart', getCountrySelectorData);
    }

    if (shouldShowCookiesBanner()) {
        body.one('click', getCookieBanner);
        body.one('keydown', getCookieBanner);
        body.one('mousemove', getCookieBanner);
        body.one('touchstart', getCookieBanner);
    }
    if (shouldShowWelcomeModal()) {
        body.one('click', getWelcomeModalData);
        body.one('keydown', getWelcomeModalData);
        body.one('mousemove', getWelcomeModalData);
        body.one('touchstart', getWelcomeModalData);
    }

    // Detect Touch Screen
    window.addEventListener('touchstart', function onFirstTouch() {
        window.USER_IS_TOUCHING = true;
        //Remove href from desktop menu first level
        //convertDesktopMenuToTouch();
        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
    }, false);



    body.one('click', replaceBlurImage);
    body.one('keydown', replaceBlurImage);
    body.one('mousemove', replaceBlurImage);
    body.one('touchstart', replaceBlurImage);

    //Begin Check videos carousels//
    $('#videoCarousel').on('ended', function () {
        $("#course-carousel-home").carousel('next');
    });
    //End Check videos carousel//

    var showGreyLogo = $(window).width() < 768 || $('.menu-logo-type').data('show-white-logo') !== true;


    navBarCollapse();

    loadCustomPageViewEvent();

    setPageVisitCookie();


    bindMenuAnimations();

    onAudioToggleClick();

    var menuOffsetElement = $(".app-menu-header").data('menu-offset-element');

    if (menuOffsetElement) {
        var menuOffsetElementDOM = $(menuOffsetElement);
        if (menuOffsetElementDOM.length > 0) {
            imageToRecalculateOffset = $(menuOffsetElement);
        }
    }

    //Affiliates Code

    if (isAffiliate() && AFFILIATE_LIB !== '') {
        loadScripts([AFFILIATE_LIB]);
    }


});

export function setLanguageCookie(languageCode, reload) {
    if (languageCode) {
        setCookie(COOKIE_LANGUAGE_CODE, languageCode, 720 * 60 * 60 * 1000); // 720 hours
    } else if (getCookie(COOKIE_LANGUAGE_CODE).length === 0) {
        setCookie(COOKIE_LANGUAGE_CODE, html.data('default-language-code'), 720 * 60 * 60 * 1000); // 720 hours
    }
    if (reload) {
        window.location.search += '&t=' + Math.random();
    }
}

function moveOnScroll(currentScroll, oldScroll) {
    var offsetToChangeClass = imageToRecalculateOffset.offset().top + imageToRecalculateOffset.height() - menuBar.height();
    if (currentScroll > oldScroll) {
        if (currentScroll > offsetToChangeClass + 10) {
            changeClass = true;
        }
    } else {
        if (currentScroll <= offsetToChangeClass - 10) {
            changeClass = false;
        }
    }
}

/*export function onTouchButton(buttonId, backgroundColor, color, touched = true) {
    if (touched) {
        backgroundColor = transformDarkenColor(backgroundColor);
    }
    const colorButton = color == '#FFFFFF' || color == '#FFF' ? '#000000' : '#FFFFFF';
    const backgroundColorButton = touched ? backgroundColor : color;
    setTimeout(() => {
        changeButtonStyle(buttonId, backgroundColorButton, backgroundColorButton, colorButton);
    });

}*/

function replaceBlurImage(ev) {
    //var canvas = $(ev.data);
    var imageTarget = $('.img-under-canvas');
    var imageSrc = "";
    if (html.is('.webp')) {
        imageSrc = imageTarget.data('img-url-webp');
    } else {
        imageSrc = imageTarget.data('img-url');
    }
    imageTarget.css('background-image', 'url(' + imageSrc + ')').addClass('fadeInCarousel');
    // $('<img/>').attr('src', imageSrc).on('load', function() {
    //     $(this).remove();
    //     imageTarget.css('background-image', 'url(' + imageSrc + ')');
    //     //canvas.fadeOut(200);
    // });
    body.off('click', null, replaceBlurImage);
    body.off('keydown', null, replaceBlurImage);
    body.off('mousemove', null, replaceBlurImage);
    body.off('touchstart', null, replaceBlurImage);
}